import { InputFieldSet } from "PFComponents/text/input_field_set";
import React from "react";

import { ThresholdsItem } from "../types";
import css from "./thresholds.module.scss";

interface ThresholdsProps {
  threshold: ThresholdsItem;
  isEdit: boolean;
  setThresholds: React.Dispatch<React.SetStateAction<ThresholdsItem>>;
  errorKey: string | null;
}

const Thresholds = ({ threshold, isEdit, setThresholds, errorKey }: ThresholdsProps) => {
  const editForm = () => (
    <div className={css.editInputForm}>
      <InputFieldSet
        label="from"
        active
        defaultValue={threshold.min}
        min={0}
        className={css.inputStyle}
        inputType="number"
        onChange={(min) => {
          setThresholds((prev) => ({
            ...prev,
            min: Number(min)
          }));
        }}
        error={errorKey === threshold.key}
      />
      <InputFieldSet
        label="to"
        active
        defaultValue={threshold.max}
        min={0}
        className={css.inputStyle}
        inputType="number"
        onChange={(max) => {
          setThresholds((prev) => ({
            ...prev,
            max: Number(max)
          }));
        }}
        error={errorKey === threshold.key}
      />
    </div>
  );

  return (
    <span className={css.wrapper}>
      {isEdit ? editForm() : `${threshold.min || 0}% - ${threshold?.max || 0}%`}
    </span>
  );
};

export default Thresholds;
